import { render, staticRenderFns } from "./Novidades.vue?vue&type=template&id=e1ed742c&scoped=true"
import script from "./Novidades.vue?vue&type=script&lang=js"
export * from "./Novidades.vue?vue&type=script&lang=js"
import style0 from "./Novidades.vue?vue&type=style&index=0&id=e1ed742c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ed742c",
  null
  
)

export default component.exports